module.exports = __webpack_public_path__ + "img/i-roles-2.5036928d.png";